const $s = globalThis.$s;

(function init() {
  if (customElements.get("hero-carousel") === undefined) {
    customElements.define(
      "hero-carousel",
      class ComponentHeroCarousel extends HTMLElement {
        /** @type {HTMLElement} */
        slidesWrapper;
        /** @type {HTMLCollection} */
        slides;
        /** @type {string | undefined} */
        effect;
        /** @type {string | undefined} */
        dots;
        /** @type {string | undefined} */
        arrows;
        /** @type {string | undefined} */
        autoplay;
        /** @type {boolean} */
        isInViewPort;
        /** @type {KeenSlider.KeenSliderInstance | false} */
        carousel;

        constructor() {
          super();
          /** @type {HTMLElement | null} */
          const slidesWrapper = this.querySelector(".keen-slider");
          if (slidesWrapper === null) {
            throw new Error("Keen slide elm not found");
          }
          this.slidesWrapper = slidesWrapper;
          this.slides = this.slidesWrapper === null ? new HTMLCollection() : this.slidesWrapper.children;
          this.effect = this.dataset.effect;
          this.dots = this.dataset.dots;
          this.arrows = this.dataset.arrows;
          this.autoplay = this.dataset.autoplay;
          this.carousel = false;
          this.isInViewPort = false;

          this.initVideos();
          this.initCarousel();
        }

        initVideos() {
          if (this.hasVideos()) {
            this.updateVideos();
            for (const button of this.slidesWrapper.querySelectorAll(".play")) {
              button.addEventListener("click", () => {
                const slide = button.closest(".keen-slider-slide");
                if (slide !== null) {
                  /** @type {NodeListOf<HTMLVideoElement>} */
                  const videos = slide.querySelectorAll(".video-wrap video");
                  for (const video of videos) {
                    this.playVideo(video);
                  }
                }
              });
            }
            for (const button of this.slidesWrapper.querySelectorAll(".pause")) {
              button.addEventListener("click", () => {
                const slide = button.closest(".keen-slider-slide");
                if (slide !== null) {
                  /** @type {NodeListOf<HTMLVideoElement>} */
                  const videos = slide.querySelectorAll(".video-wrap video");
                  for (const video of videos) {
                    this.pauseVideo(video);
                  }
                }
              });
            }
            globalThis.addEventListener("mediaChange", () => {
              this.updateVideos();
            });

            globalThis.addEventListener(
              "scroll",
              $s.throttle(() => {
                const _isInViewPort = $s.isInViewport(this.slidesWrapper);
                if (_isInViewPort !== this.isInViewPort) {
                  this.updateVideos();
                }
              }, 500),
            );
          }
        }

        updateVideos() {
          this.isInViewPort = $s.isInViewport(this.slidesWrapper);

          const currentSlide = this.getCurrentSlide();
          if (currentSlide === null) {
            console.error("Current slide is null");
            return;
          }
          if (this.isInViewPort) {
            this.loadVideos(currentSlide);
            if (this.carousel) {
              for (const video of this.slidesWrapper.querySelectorAll("video")) {
                this.pauseVideo(video);
              }
            }
            /** @type {NodeListOf<HTMLVideoElement>} */
            const videos1 = currentSlide.querySelectorAll("video");
            for (const video of videos1) {
              if ($s.isVisible(video)) {
                this.playVideo(video);
              }
            }
          } else {
            /** @type {NodeListOf<HTMLVideoElement>} */
            const videos1 = currentSlide.querySelectorAll("video");
            for (const video of videos1) {
              if ($s.isVisible(video)) {
                this.pauseVideo(video);
              }
            }
          }
        }

        hasVideos() {
          return this.slidesWrapper.querySelectorAll("video").length > 0;
        }

        loadVideos(/** @type {HTMLElement} */ slide) {
          /** @type {NodeListOf<HTMLVideoElement>} */
          const videos1 = slide.querySelectorAll("video");
          for (const video of videos1) {
            if ($s.isVisible(video) && video.dataset.initialized !== "true") {
              const source = video.querySelector("source");
              if (source === null || source.dataset.src === undefined) {
                throw new Error("Video source not found");
              }
              source.setAttribute("src", source.dataset.src);
              video.dataset.initialized = "true";
              video.load();
            }
          }
        }

        playVideo(/** @type {HTMLVideoElement | null} */ video) {
          if (video !== null) {
            const slide = video.closest(".keen-slider-slide");
            $s.playMedia(video);
            if (slide !== null) {
              const playElm = slide.querySelector(".play");
              if (playElm !== null) {
                playElm.classList.add("hide");
              }
              const pauseElm = slide.querySelector(".pause");
              if (pauseElm !== null) {
                pauseElm.classList.remove("hide");
              }
            }
          }
        }

        pauseVideo(/** @type {HTMLVideoElement | null} */ video) {
          if (video !== null) {
            const slide = video.closest(".keen-slider-slide");
            $s.pauseMedia(video);
            if (slide !== null) {
              const playElm = slide.querySelector(".play");
              if (playElm !== null) {
                playElm.classList.remove("hide");
              }
              const pauseElm = slide.querySelector(".pause");
              if (pauseElm !== null) {
                pauseElm.classList.add("hide");
              }
            }
          }
        }

        initCarousel() {
          if (this.slides.length > 1) {
            /** @type {HTMLElement | null} */
            const keenDots = this.querySelector(".keen-dots");
            /** @type {HTMLElement | null} */
            const keenPrev = this.querySelector(".keen-arrow.prev");
            /** @type {HTMLElement | null} */
            const keenNext = this.querySelector(".keen-arrow.next");
            this.carousel = new KeenSlider(this.slidesWrapper, {
              mode: "snap",
              loop: true,
              wheel: false,
              dots: this.dots ? keenDots : false,
              prevButton: this.arrows ? keenPrev : false,
              nextButton: this.arrows ? keenNext : false,
              customAnimation: this.effect === "fade" ? "fade" : false,
              setContainerHeight: this.effect === "fade",
              autoplay: this.autoplay,
              slideChanged: () => {
                if (this.hasVideos()) {
                  this.updateVideos();
                }
              },
            });
          } else {
            this.slidesWrapper.classList.add("initialized");
          }
        }

        getCurrentSlide() {
          if (this.carousel !== false && this.carousel.currentSlide !== undefined) {
            const currSlide = this.carousel.currentSlide();
            if (currSlide !== null && currSlide !== undefined) {
              return currSlide;
            }
          }
          const ret1 = /** @type {HTMLElement | null} */ (this.slidesWrapper.firstChild);
          return ret1;
        }
      },
    );
  }
})();

export {};
